export default function Footer (){
  return (
    <div id="footer">
      <div>
        <p>公司名称 : {process.env.REACT_APP_CN_CLINIC_NAME}</p>
        <p>Copyright 2025 {process.env.REACT_APP_CN_CLINIC_NAME}. All Right Reserved.</p>
      </div>
    </div>
  )
}